import React from 'react'
import { Box, Button, Modal, TextInput, Text } from 'elements'
import DatePeriodInput from 'components/ui/input/DatePeriodInput'
import ModalContent from '../../app/ModalContent'
import ModalCloseButton from '../../app/ModalCloseButton'
import IconInput from '../../ui/input/IconInput'

export default function FirstClientIntegrationSubmitStep({
  onBack,
  submitting,
  reportPeriod,
  setReportPeriod,
  reportName,
  setReportName,
  valid,
  handleCreate,
  onClose,
}) {
  return (
    <>
      <ModalContent p="gigantic">
        <ModalCloseButton onClose={onClose} />
        <Text mb="large">Step 3: Select date range and run report</Text>
        <Text fontSize="xsmall" color="neutral.0" mb="xlarge">
          This first Intro Report includes a comprehensive test of all anomalies.
        </Text>
        <Box mb="xxxlarge">
          <TextInput
            disabled={submitting}
            value={reportName}
            onChange={(event) => setReportName(event.target.value)}
            placeholder="Report name (optional)"
          />
        </Box>
        <DatePeriodInput
          disabled={submitting}
          value={reportPeriod}
          onChange={setReportPeriod}
          customInput={<IconInput icon="calendar" styleProps={{ color: 'neutral.0' }} />}
        />
      </ModalContent>
      <Modal.Footer
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        width="100%"
        px="gigantic"
        pb="gigantic"
      >
        <Button disabled={submitting} onPress={onBack} kind="alt-neutral">
          Back
        </Button>
        <Button disabled={!valid || submitting} kind="primary" onPress={handleCreate}>
          {submitting ? 'Running...' : 'Run Report'}
        </Button>
      </Modal.Footer>
    </>
  )
}
